import { render } from "./StatsWidgetRow.vue?vue&type=template&id=217c2fb4"
import script from "./StatsWidgetRow.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetRow.vue?vue&type=script&lang=ts"
script.render = render

export default script